/******************************************************************************************
 *	Market Segments
 *******************************************************************************************
 *
 * The MARKET_SEGMENTS constant contains information about market segments such as name and CoralUI icon class name.
 * The MarketSegments service returns a promise that is resolved with the market segments available for creating a customer.
 *
 */
(function() {
  

  angular
    .module('rcServices.marketSegments', [])
    .constant('MARKET_SEGMENTS', {
      COMMERCIAL: {
        label: 'global.marketSegments.commercial',
        iconClass: 'icon-shoppingcart',
        offerCode: 'COM'
      },
      EDUCATION: {
        label: 'global.marketSegments.education',
        iconClass: 'icon-education',
        offerCode: 'EDU'
      },
      GOVERNMENT: {
        label: 'global.marketSegments.government',
        iconClass: 'icon-bidrule',
        offerCode: 'GOV'
      },
      UNKNOWN: {
        label: 'global.marketSegments.unknown',
        iconClass: 'icon-help-circle',
        offerCode: 'COM'
      }
    })
    .service(
      'MarketSegments',
      /* @ngInject */
      function($q, MARKET_SEGMENTS) {
        //In the future this service will request data from the server.
        //So use a promise that is immediately resolved for now so that adding AJAX to the mix won't affect components using this service.
        this.get = function() {
          var deferred = $q.defer();

          var data = [];
          for (var segment in MARKET_SEGMENTS) {
            if (MARKET_SEGMENTS[segment] !== MARKET_SEGMENTS.UNKNOWN) {
              data.push({id: segment, label: MARKET_SEGMENTS[segment].label});
            }
          }

          deferred.resolve(data);
          return deferred.promise;
        };
      }
    );
})();
